function sortSortOptions(a) {
  if (a.code === 'most-recent-sr') return -1;
  return 1;
}

export function getSortOptions(options, selectedFilter) {
  let sortOptions = [];

  if (Array.isArray(options)) {
    sortOptions = options.sort(sortSortOptions).map(o => {
      const label =
        typeof o?.code === 'string'
          ? o.code
              .replace('-sr', '')
              .split('-')
              .map(w => w.charAt(0).toUpperCase() + w.substring(1))
              .join(' ')
          : '';

      return {
        label,
        shouldResetFilter:
          o?.code === 'highest-rated-sr' || o?.code === 'lowest-rated-sr'
            ? !(selectedFilter?.filter?.label === 'All Ratings')
            : false,
        value: o?.code
      };
    });
  }

  return sortOptions;
}
